<div class="bg-white p-2">
    <div class="row">
        <div class="col-lg-2">
            <div class="form-group">
                <label for="ragione_sociale" class="control-label col-form-label"> Inizio</label>
                <input class="form-control" type="date" [(ngModel)]="filtro.inizio" (ngModelChange)="Refresh()">
            </div>
        </div>
        <div class="col-lg-2">
            <div class="form-group">
                <label for="ragione_sociale" class="control-label col-form-label"> Fine</label>
            <input class="form-control" (change)="Refresh()" type="date" [(ngModel)]="filtro.fine"
                [ngModelOptions]="{updateOn: 'change'}">
            </div>
        </div>
        <div class="col-lg-2">
            <div class="form-group">
                <label for="ragione_sociale" class="control-label col-form-label"> Stato</label>
            <ng-multiselect-dropdown [settings]="dropdownSettings" placeholder="{{'stato' | translate}}" [data]="stati"
                [(ngModel)]="filtro.statoObject" (ngModelChange)="Refresh()">
            </ng-multiselect-dropdown>
            </div>
        </div>
    </div>
    <div class="row p-4 bg-white">
        <button type="button" class=" ml-auto btn btn-cyan py-2" (click)='add()'><i
            class="fas fa-plus  font-14 mr-1 text-white"></i>
            <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
        </button>
    </div>
    <div>
        <table class="table bg-white table-hover align-middle mb-0 no-wrap">
            <tr>
                <th>Data Inizio</th>
                <th>Data Fine</th>
                <th>Stato</th>
                <th>Note</th>
                <th>Azioni</th>
            </tr>
            <tr *ngFor="let bilancio of bilanci">
                <td>{{bilancio.dataInizio}}</td>
                <td>{{bilancio.dataFine}}</td>
                <td *ngIf="!bilancio?.data_pagamento_p">In Lavorazione</td>
                <td *ngIf="bilancio?.data_pagamento_p && bilancio?.data_pagamento_e">Validato</td>
                <td *ngIf="bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e">Approvato</td>
                <td *ngIf="!bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e && bilancio?.dataRiesamina">Riesaminare</td>
                <td *ngIf="!bilancio?.data_pagamento_p && bilancio.note != 'null'">{{bilancio.note}}</td>
                <td *ngIf="!bilancio?.data_pagamento_p && bilancio.note == 'null'"></td>
                <td *ngIf="bilancio?.data_pagamento_p && bilancio?.data_pagamento_e">{{bilancio.noteValidazione}}</td>
                <td *ngIf="bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e">{{bilancio.noteApprovazione}}</td>
                <td *ngIf="!bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e && bilancio?.dataRiesamina">{{bilancio.noteRiesamina}}</td>
                <td><i (click)="open(bilancio)" class="f-20 fas fa-pencil-alt text-info"></i> <i (click)="delete(bilancio)" class="pl-1 f-20 ti-trash text-danger"></i></td>
            </tr>
        </table>
    </div>
</div>